import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Header from "../../Components/Header/Header";
import { about, contact1, contact2, contact3, hero, service2 } from "../../assets";
import HeaderOther from '../../Components/HeaderOther/HeaderOther';
import Title from '../../Components/Title/Title';

export default function Contact() {

  const [activeButton, setActiveButton] = useState("Startup");
  const buttons = [
    { key: "Startup", label: "Startup" },
    { key: "Veb-sayt hazırlanması", label: "Veb-sayt hazırlanması" },
    { key: "Mobil Tətbiqlərin Hazırlanması", label: "Mobil Tətbiqlərin Hazırlanması" },
    { key: "Təlimçi Bazası", label: "Təlimçi Bazası" },
    { key: "SMM Xidmətlər", label: "SMM Xidmətlər" },
  ];


  const { t, i18n } = useTranslation();
  return ( 
    <>
  
   <HeaderOther/>
   <Title title="Əlaqə"/>
   <div className='max-w-containerSm md:max-w-container mx-auto pt-[194px] md:pt-[240px]'>
   <div className="md:flex"> 
    <div className="md:w-[549px]">
 <p className="text-black text-base font-normal mb-2">Ad, soyad*</p>
 <input className="border-[#d2d2d2] border-[0.6px] rounded-lg h-10 w-full mb-7 p-2"></input>
 <p className="text-black text-base font-normal mb-2">Əlaqə nömrəsi*</p>
 <input className="border-[#d2d2d2] border-[0.6px] rounded-lg h-10 w-full mb-7 p-2"></input>
 <p className="text-black text-base font-normal mb-2">E-mail*</p>
 <input className="border-[#d2d2d2] border-[0.6px] rounded-lg h-10 w-full mb-7 p-2"></input>
 <p className="text-black text-base font-normal mb-2">Mesaj</p>
 <textarea className="border-[#d2d2d2] border-[0.6px] rounded-lg h-[114px] w-full mb-7 p-2"></textarea>
 <button className="text-base font-normal w-[148px] h-[44px] rounded-lg border bg-[#898989] text-[white]">Göndər</button>
    </div>
    <div className="md:w-[417px] md:ml-[159px] mt-[44px] md:mt-0">
      <p className="text-black text-[18px] md:text-[24px] font-semibold mb-11">Köməyə ehtiyacınız var? Bizimlə əlaqə saxlayın</p>
     <div className="flex"> 
      <img className="w-10 h-10" src={contact1}></img>
      <div className="ml-6">
        <p className="text-[16px] font-medium">Əlaqə nömrəsi</p>
        <p className="text-[18px] font-semibold">+994 55 236 75 00</p>
          <p className="text-[18px] font-semibold">+994 55 237 75 00</p>
           <p className="text-[18px] font-semibold">+994 50 357 39 99</p>
              <p className="text-[18px] font-semibold">+994 50 587 99 72</p>
                <p className="text-[18px] font-semibold">+994 55 265 41 81</p>
      </div>
     </div> 
     <div className="flex mt-9"> 
      <img className="w-10 h-10" src={contact2}></img>
      <div className="ml-6">
        <p className="text-[16px] font-medium">E-mail</p>
        <p className="text-[18px] font-semibold">afcity@gmail.com</p>
      </div>
     </div>
     <div className="flex mt-9"> 
      <img className="w-10 h-10" src={contact3}></img>
      <div className="ml-6">
        <p className="text-[16px] font-medium">Ünvan</p>
        <p className="text-[18px] font-semibold">Rəşid Behbudov küçəsi</p>
      </div>
     </div>
      </div>
   </div>
     </div>
    </>
  );
}